import { Divider } from "@mui/material";
import About from "./About";
import HelpRoles from "./Roles";
import { InternalUserRoles, Roles } from "../../constants/roles";
import { useAuth } from "../../context/AuthContext";
import { ProtectedTabs, TabCollection } from "../../components/ProtectedTabs";
import { useLocation } from "react-router-dom";

export enum HelpTab {
  Roles = "Roles",
  About = "About MIDAS 3",
  GuestOnBoarding = "Guest Onboarding",
}

const Help = () => {
  const { hasRole } = useAuth();
  const location = useLocation();
  const tabValueFromLocationState = (location.state as { tabValue?: HelpTab })?.tabValue;
  const defaultTab = hasRole(Roles.MidasGuest)
    ? HelpTab.GuestOnBoarding
    : tabValueFromLocationState ?? HelpTab.Roles;

  const tabs: TabCollection = {
    [HelpTab.Roles]: {
      component: <HelpRoles />,
      restrictedToRoles: InternalUserRoles,
    },
    [HelpTab.About]: {
      component: <About />,
      restrictedToRoles: InternalUserRoles,
    },
    [HelpTab.GuestOnBoarding]: {
      component: <>Coming Soon</>,
      restrictedToRoles: [Roles.MidasGuest],
    },
  };

  return (
    <>
      <span className="pageheader">MIDAS 3 Help</span>
      <Divider className="dividerbar" />
      <ProtectedTabs tabs={tabs} defaultTab={defaultTab} />
    </>
  );
};

export default Help;
